export enum WorkflowStatusEnum {
  ALL = 0,
  ProjectCreated = 9,
  OrderWritten = 1,
  PoSent = 2,
  ProofSent = 3,
  ProofApproved = 4,
  InProduction = 5,
  Shipped = 6,
  Delivered = 7,
  Complete = 8,
  Cancelled = 10,
  RevisionRequested = 12,
  Archived = 11,
}
